import { FC, useMemo } from 'react'
import { MixedAccountsTableItem } from 'selectors/linkageSelectors'

type AccountActionHandlerProps = {
  accountInfo: MixedAccountsTableItem
}

export const AccountActionViewProviderSiteHandler: FC<AccountActionHandlerProps> = (props) => {
  const { accountInfo, children } = props
  const { type, providerInfo } = accountInfo
  const { providerUrl, providerName } = providerInfo

  const isExist = useMemo(() => {
    return type !== 'manual'
  }, [type])

  if (!isExist) {
    return null
  }

  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={ providerUrl || `http://www.google.com/search?q=${ providerName }+login&btnI` }
    >
      { children }
    </a>
  )
}
